<template>
  <vs-popup title="Atenção !!!" @close="clickNo" :active.sync="myPopUpYesOrNo">
    <div class="content-modal">
      <div class="text-center">
        <p>
          <span>{{message}}</span>
        </p>
      </div>
    </div>
    <br>
    <footer class="footer-modal">
      <hr>
      <div class="btn-group">
        <div class="btn-space"></div>
        <div class="btn-print-modal text-right">
          <b-button class="no-print" @click="clickYes" variant="info">Sim</b-button>
        </div>
        <div class="btn-aprove-modal text-right">
          <b-button class="no-print" @click="clickNo" variant="info">Não</b-button>
        </div>
      </div>
    </footer>
  </vs-popup>
</template>

<script>
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";

export default {
  name: "PopUpYesOrNo",
  props: ["message", "event"],
  data() {
    return {
      myPopUpYesOrNo: false
    };
  },
  mounted() {
    this.listeningEventBus();
  },
  methods: {
    listeningEventBus() {
      EventBusExpenses.$on(this.event, data => {
        this.myPopUpYesOrNo = data;
      });
    },
    clickYes() {
      this.myPopUpYesOrNo = false;
      this.$emit("clickYes", true);
    },

    clickNo() {
      this.$emit("closePopUpYesOrNo", true);
      this.myPopUpYesOrNo = false;
    }
  }
};
</script>

<style>
</style>
